<template>
  <svg
    id="Сгруппировать_3536"
    data-name="Сгруппировать 3536"
    xmlns="http://www.w3.org/2000/svg"
    width="122.407"
    height="129.772"
    viewBox="0 0 122.407 129.772"
  >
    <g
      id="Сгруппировать_3538"
      data-name="Сгруппировать 3538"
      transform="translate(52.225 41.954)"
    >
      <path
        id="Контур_3605"
        data-name="Контур 3605"
        d="M162.962,468.851a59.557,59.557,0,0,1,10.7.885,31.969,31.969,0,0,1,8.315,2.6,14.865,14.865,0,0,1,5.379,4.19,9.085,9.085,0,0,1,1.9,5.666,9.219,9.219,0,0,1-2.446,6.374,7.882,7.882,0,0,1-6.113,2.714,11.077,11.077,0,0,1-3.424-.648q-1.957-.648-4.157-1.358t-4.646-1.357a19.491,19.491,0,0,0-5.013-.649,22.839,22.839,0,0,0-9.537,1.888,19.4,19.4,0,0,0-6.969,5.253,24.005,24.005,0,0,0-4.341,8.026,33,33,0,0,0-1.528,10.328,32.309,32.309,0,0,0,1.467,9.974,23.9,23.9,0,0,0,4.157,7.85,18.624,18.624,0,0,0,6.541,5.134,19.822,19.822,0,0,0,8.62,1.83,36.237,36.237,0,0,0,7.153-.591,36.693,36.693,0,0,0,5.013-1.357q2.139-.766,3.729-1.357a9.767,9.767,0,0,1,3.424-.59,8.412,8.412,0,0,1,6.541,2.478,9.092,9.092,0,0,1,2.262,6.374,9.258,9.258,0,0,1-2.2,6.079,16.931,16.931,0,0,1-5.991,4.427,37.121,37.121,0,0,1-8.743,2.715,55.874,55.874,0,0,1-10.454.943,46.116,46.116,0,0,1-17.851-3.3,38.474,38.474,0,0,1-13.45-9.148,40.856,40.856,0,0,1-8.5-13.81,48.367,48.367,0,0,1-3-17.175,50.666,50.666,0,0,1,3.057-17.941,40.909,40.909,0,0,1,8.681-14.047,38.58,38.58,0,0,1,13.633-9.147A46.949,46.949,0,0,1,162.962,468.851Z"
        transform="translate(-119.801 -468.851)"
        fill-rule="evenodd"
        fill="#ffb133"
      />
    </g>
    <path
      id="Контур_3606"
      data-name="Контур 3606"
      d="M109,507.734c1.527-9.588,12-24.629,11.972-24.642a38.325,38.325,0,0,0-35.19-56.174,38.275,38.275,0,0,1-.647,57.544c-6.893,5.929-8.946,8.358-13.143,16.011A38.329,38.329,0,0,0,125.6,551.224,46.617,46.617,0,0,1,109,507.734Z"
      transform="translate(-67.576 -426.897)"
      fill-rule="evenodd"
      fill="#ffb133"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconSushifox',
  }
</script>
